<div class="version-item" [class.active]="isActive()" (click)="onRestore()">
  <div class="version-info">
    <span class="version-label">{{ version().instruction }}</span>
    <span class="version-date">{{ version().createdAt | date: 'dd/MM/yyyy HH:mm' }}</span>
  </div>

  <div class="version-actions">
    @if (showChatAction()) {
      <button mat-icon-button class="chat-btn" matTooltip="{{ 'Search.OpenChat' | translate }}" (click)="onChat($event)">
        <mat-icon>chat</mat-icon>
      </button>
    }
    @if (isActive()) {
      @if (showInsertAction()) {
        @if (isInserting()) {
          <mat-spinner diameter="18" class="me-2"></mat-spinner>
        } @else {
          <button mat-icon-button class="insert-btn-tile" matTooltip="{{ 'ContentRefiner.InsertButton' | translate }}" (click)="onInsert($event)" [disabled]="isInserting()">
            <mat-icon>arrow_insert</mat-icon>
          </button>
        }
      }
      <mat-icon class="check-icon">check_circle</mat-icon>
    } @else {
      <button mat-icon-button class="delete-btn" matTooltip="{{ 'ContentRefiner.DeleteVersionConfirm' | translate }}" (click)="onDelete($event)">
        <mat-icon>delete</mat-icon>
      </button>
    }
  </div>
</div>
